import { Typography } from "@mui/material";

export const TaxAndDeliveryRechargeNotice = ({
  businessName,
}: {
  businessName: string;
}) => (
  <Typography
    variant="caption"
    sx={{ mt: 1, color: "text.secondary", textAlign: "right" }}
  >
    {`** Taxes, delivery charges, and any other costs required to complete this order will be recharged to ${businessName} after they are incurred`}
  </Typography>
);
